export type CommentScoreTag = {
  id: number;
  name: string;
  dimension: string;
  dimensionName: string;
};

export type ExternalEvaluateInternalParams = {
  parentTaskId: number;
  score: number;
  content: {
    currInternalContact: number;
    currExternalContact: string;
    efficiency: string;
    crossStage: boolean;
    comment: string;
  };
  tags: CommentScoreTag[];
};

export type ExternalEvaluateInternalResponse = {
  parentTaskId: number;
  score: number;
  content: {
    currInternalContact: {
      uniqueId: number;
      nickName: string;
      avatar: string;
      taxRate: string;
      userRate: string;
      email: string;
    };
    currExternalContact: string;
    efficiency: string;
    crossStage: boolean;
    comment: string;
  };
  tags: CommentScoreTag[];
};

export enum CommentTypeEnum {
  ExternalInternal = 'EXTERNAL_INTERNAL',
  AllocatorExternal = 'ALLOCATOR_EXTERNAL',
}
